import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Document } from '../models/document';
import { createDocumentEndpoint } from './const';

export const createDocument = (document: Document) => {
    return getHttpClient().post({ url: createDocumentEndpoint, data: JSON.stringify(document) });
};
